import http from '@/http-common';

class FilialService {
  async list() {
    return http.get('/filial/selecionar');
  }

  async get(filial) {
    return http.get(`${filial}`);
  }

  async getForm(filial) {
    return http.get(`/filial/form/${filial}`);
  }

  async saveDFe(inputModel) {
    return http.post('/filial/updateDFe/', inputModel);
  }

  async save(inputModel) {
    return http.post('/filial/', inputModel);
  }

  async search(filial) {
    return http.post('/filial/search', filial, {});
  }

  async listByFuncionarioAcessado(inputModel) {
    return http.post('/filial/listByFuncionarioAcessado', inputModel);
  }

  async nextCodigo() {
    return http.get('/filial/nextCodigo');
  }

  async createNewFilialTransaction(inputModel) {
    return http.post('/filial/add', inputModel);
  }

  async getCodigoNomeSerial(filialCodigo) {
    return http.get(`/filial/getCodigoNomeSerial/${filialCodigo}`);
  }

  async getDadosPlaca(placa, filialCodigo) {
    return http.post(`/filial/getDadosPlaca/${placa}/${filialCodigo}`);
  }
}

export default new FilialService();
